import SmoothScroll from './smoothScroll'
export default SmoothScroll